import { Component, inject } from '@angular/core';
import { DATE_TIME_FORMAT } from '@cl/shared/constants';
import { NotificationHistory } from '@cl/shared/models/notification-history.model';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

@Component({
    selector: 'cl-notification-history-modal',
    standalone: false,
    templateUrl: './notification-history-modal.component.html',
    styleUrl: './notification-history-modal.component.less',
})
export class NotificationHistoryModalComponent {
    DATE_TIME_FORMAT: string = DATE_TIME_FORMAT;
    readonly notificationHistory: NotificationHistory[] = inject(NZ_MODAL_DATA);

    expandSet: Set<number> = new Set<number>();

    onExpandChange(id: number, checked: boolean): void {
        if (checked) {
            this.expandSet.add(id);
        } else {
            this.expandSet.delete(id);
        }
    }
}
